import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const links = [{
    name: 'עבודות',
    href: '#work'
  }, {
    name: 'שירותים',
    href: '#services'
  }, {
    name: 'תהליך',
    href: '#process'
  }, {
    name: 'צוות',
    href: '#team'
  }, {
    name: 'צור קשר',
    href: '#contact'
  }];
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-[#0a0a0f]/80 backdrop-blur-lg border-b border-white/5 py-4' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} data-id="element-89">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-90">
        <a href="#" className="text-3xl font-display font-black tracking-tighter text-white" data-id="element-91">
          פיקסל<span className="text-gradient" data-id="element-92">.</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-93">
          {links.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-white/70 hover:text-white transition-colors relative group" data-id="element-94">
              {link.name}
              <span className="absolute -bottom-1 right-0 w-0 h-[2px] bg-gradient-to-r from-[#7c5cfc] to-[#22d3ee] transition-all duration-300 group-hover:w-full" data-id="element-95" />
            </a>)}
          <a href="#contact" className="relative inline-flex items-center justify-center px-6 py-2.5 text-sm font-bold text-white transition-all duration-300 bg-white/5 border border-white/10 rounded-full hover:bg-white/10 hover:scale-105 hover:shadow-[0_0_20px_rgba(124,92,252,0.3)] overflow-hidden group" data-id="element-96">
            <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-[#7c5cfc] via-[#22d3ee] to-[#ff2d8a] opacity-0 group-hover:opacity-20 transition-opacity duration-300" data-id="element-97" />
            בואו נדבר
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-98">
          {mobileMenuOpen ? <X size={24} data-id="element-99" /> : <Menu size={24} data-id="element-100" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-101">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#0a0a0f] border-b border-white/10 overflow-hidden" data-id="element-102">
            <div className="flex flex-col px-6 py-8 gap-6" data-id="element-103">
              {links.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-xl font-display font-bold text-white/80 hover:text-white" data-id="element-104">
                  {link.name}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.header>;
}